import { render, staticRenderFns } from "./SimpleBtn.vue?vue&type=template&id=4db64d82&scoped=true&"
import script from "./SimpleBtn.vue?vue&type=script&lang=js&"
export * from "./SimpleBtn.vue?vue&type=script&lang=js&"
import style0 from "./SimpleBtn.vue?vue&type=style&index=0&id=4db64d82&scoped=true&lang=sass&"
import style1 from "./SimpleBtn.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db64d82",
  null
  
)

export default component.exports